import { Theme } from "src/app/interfaces/theme.model";
const pmucDefaults = { promoImg: "url(assets/images/promo_3.png)" };

export const PmucTheme: Theme = {
  name: "pmuc",
  useGateway: false,
  showTcktVerification: false,
  properties: {
    //-------------------------  header-----------------------------
    "--app-background-base": "#fff",
    "--app-background-header": "#fff",
    "--app-background-body": "#e6e6e6",
    "--app-background-turf-home": "#e6e6e6",
    "--app-background-footer": "#bbbaba",
    "--app-background-left-menu": "#037b3a",
    "--app-background-right-menu": "",
    "--app-background-nav": "#e6177f",
    "--app-background-nav-hover": "#ff05a7c4",
    "--app-background-nav-border-bottom": "#d40c71",
    "--app-background-main": "rgb(242, 242, 242)",
    "--app-background-home": "#037b3a",
    "--app-color-tournament": "#154e2b",
    "--app-color-heading": "#77777a",
    "--app-color-header": "#77777a",
    "--app-color-body": "#5d5d5d",
    "--app-color-footer": "#9ACC09",
    "--app-color-nav": "#fff",
    "--app-color-main": "#212121",
    "--app-color-forgot_pw": "#e6177f",
    "--app-background-primary-tint": "",
    "--app-background-input-primary": "#dedede",
    "--app-background-secondary-tint": "#e6177f",

    //-------------------------  owl calendar-----------------------------
    "--app-background-calendar-header": "#7fc31c",
    //-------------------------  side menu-----------------------------
    "--app-background-side-menu": "#e6e6e6",
    "--app-color-side-menu": "#fff",
    // lexique
    "--app-color-lexique": "#fff",
    "--app-background-lexique": "linear-gradient(to right, #ffaa00, #fac04b)",
    "--app-background-cmtJr": "linear-gradient(to right, #17a2b8, #4fdbf1)",
    "--app-color-cmtJr": "#fff",

    // promotions
    "--app-color-promotions": "#fff",
    "--app-background-promotions":
      "linear-gradient(to right, #588a11, #7fc41c)",
    "--app-background-border-promotions":
      "linear-gradient(to right, #588a11, #7fc41c)",

    // cagnottes
    "--app-color-cagnotte-header": "#fff",
    "--app-background-cagnotte-header": "#5d5d5d",
    //-------------------------  second nav-----------------------------
    "--app-background-second-nav": "#e6177f",
    "--app-background-second-nav-hover": "#e6177f",
    "--app-color-second-nav": "#fff",
    "--app-background-second-nav-selected": "#fff",
    "--app-color-second-nav-selected": "#e6177f",
    "--app-background-border-second-nav-selected": "#e6177f",
    "--app-color-second-nav-course": "#77777a",

    //-------------------------  rapports-----------------------------
    "--app-color-rapport": "#e6177f",
    "--app-background-rapport": "#e6177f",
    "--app-background-rapport-header-border": "#9ACC09",

    //-------------------------  top races-----------------------------
    "--app-color-top-race-RN": "#5d5d5d",
    "--app-color-top-race-CN": "#5d5d5d",
    "--app-color-top-race-time": "#bbbbbb",
    "--app-color-top-race-time-up": "#5d5d5d",
    // "--app-background-top-race":"linear-gradient(0deg, #a20957, #e6177f)",
    "--app-background-top-race": "#fff",

    //-------------------------  meetings-----------------------------
    "--app-color-meeting-link": "#8e8d8d",
    "--app-background-meeting-link": "#e6e6e6",
    "--app-color-meeting-link-selected": "#e6177f",
    "--app-background-meeting-link-selected": "#ffff",
    "--app-background-meeting-link-borders": "#fa7f22",

    //-------------------------  race details-----------------------------
    "--app-color-race-time": "#5d5d5d",
    //-------------------------  race list-----------------------------
    "--app-color-table-header": "",
    "--app-color-table-header-border-left": "#dad8d8",
    "--app-color-table-headings": "",
    "--app-color-table": "#5d5d5d",
    "--app-color-table-subdetails": "#5d5d5d",
    "--app-color-table-numbers": "#5d5d5d",
    "--app-color-table-open": "#fff",
    "--app-color-table-content-open": "#5d5d5d",
    "--app-background-table-open": "#e6177f",
    "--app-background-wrap-race": "#fff",
    //-------------------------  race details-----------------------------
    "--app-color-registration": "#5d5d5d",
    "--app-background-registration": "#bbbaba",
    "--app-background-registration-input": "#dedede",
    "--app-color-registration-input": "#000",
    "--app-background-registration-input-border": "#969292",
    "--app-color-registration-validation-error": "#e6177f",

    //-------------------------  footer-----------------------------
    "--app-color-footer-heading-1": "#00ff75",
    "--app-color-footer-body": "",
    // reset password
    "--app-color-resetpw-header": "#bbbaba",
    //-------------------------  transactions history and account -----------------------------
    "--app-background-transactions": "#fff",
    "--app-background-profile-body": "#bbbaba",
    "--app-background-profile-header": "#e6177f",
    "--app-background-profile-header-border": "#fff",
    "--app-background-profile-section-header": "#e6177f",
    "--app-color-profile-section-activeheader": "#fff",
    "--app-color-profile-section-header": "#fff",
    "--app-color-profile-input": "#5d5d5d",
    "--app-color-profile-input-placeholder": "#eee",
    "--app-background-profile-input": "#e6e6e6",
    "--app-color-profile-input-border": "#bbbaba",
    "--app-color-profile-input-lable": "#5d5d5d",
    "--app-background-transactions-body": "#bbbaba",
    "--app-color-transactions-header": "#5d5d5d",
    "--app-color-transactions-header-input-border": "#fff",
    "--app-color-transactions-header-input-lable": "#fff",
    "--app-color-transactions-header-input": "#fff",
    "--app-color-transaction-tab-secondary": "#628207",
    "--app-color-transaction-tab-primary": "#5d5d5d",
    "--app-background-transactions-tabs": "#bbbaba",
    "--app-color-accounts": "#5d5d5d",
    "--app-color-accounts-header": "#fff",
    "--app-color-accounts-item-border": "#77777a",
    "--app-color-accounts-item": "#5d5d5d",
    "--app-background-row-even": "#fff",
    "--app-background-row-odd": "#dedede",
    "--app-color-transactions-container-color": "#154e2b",
    "--app-background-transaction-methods": "#a1a1a2",
    "--app-background-active-trans-method":
      "linear-gradient(to right, #588a11, #7fc41c)",
    "--app-color-methods-border-left": "#a1a1a2",
    "--app-color-border-acc-input-focus": "#a1a1a2",

    //-------------------------  betslip-----------------------------
    "--app-color-betslip-header": "#fff",
    "--app-background-betslip-header": "#e6177f",
    "--app-background-betSummary": "#9ACC09",
    "--app-color-betSummary": "#fff",
    "--app-color-yello-odd": "#9ACC09",
    "--app-color-background-dropdown": "#e6177f",
    "--app-color-betslip": "#77777a",
    "--app-background-betslip": "#fff",
    "--app-color-betslip-amount": "#e6177f",
    "--app-color-betslip-meeting": "#777777",
    //-------------------------  betslip-----------------------------
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",

    "--app-background-checkbox-input": "#9ACC09",
    "--app-color-checkbox-input-border": "#fff",
    //-------------------------  account modal -----------------------------

    "--app-background-modal-window": "#77777a",
    "--app-color-modal-window": "#fff",

    //-------------------------  buttons-----------------------------
    "--app-color-button-primary": "#fff",
    "--app-background-button-primary": "#e6177f",
    "--app-color-button-secondary": "#fff",
    "--app-color-button-secondary-border": "#e6177f",
    "--app-background-button-secondary": "#e6177f",
    "--app-color-button-secondary-invert": "#e6177f",
    "--app-color-button-secondary-border-invert": "#e6177f",
    "--app-background-button-secondary-invert": "#fff",
    "--app-color-bet-button": "#fff",
    "--app-background-bet-button": "#e6177f",
    "--app-background-bet-button-tint": "#5b8e12",
    "--app-color-rapport-button": "#e6177f",
    "--app-background-rapport-button-border": "#e6177f",
    "--app-background-rapport-button": "#fff",
    "--app-color-betSlip-button": "#fff",
    "--app-background-betSlip-button": "#e6177f",

    //-------------------------  Account Modal-----------------------------
    "--app-background-main-modal": "#e6177f",
    "--app-color-main-modal": "#efd7c2",
    "--app-color-main-modal-border": "#176334",
    // ------------------------ footer -----------------------------------
    // ------------------------faq ---------------------------------------
    "--app-color-faq-header": "#5d5d5d",
    "--app-color-footer-icon": "#777",

    // ------------------------- default images
    "--img-default-promo": pmucDefaults.promoImg,
  },
  country: "CM",
  contact: {
    tel: "+225 07 07 07 18 89",
    email: "hotline@lonaci.ci",
    fax: "+225 01 01 51 44 00",
    addresse: "e",
  },
  whiteIcon: true,
  betOptions: {
    version: "4.3",
  },
};
